import {IconButton, alpha, styled} from '@mui/material';

const StyledIconButton = styled(IconButton)`
	background-color: ${({theme}) => alpha(theme.palette.common.black, 0.3)};
	color: ${({theme}) => theme.palette.common.white};

	&.Mui-disabled {
		display: none;
	}

	&:hover {
		background-color: ${({theme}) => theme.palette.action.active};
	}
`;

const StyledImage = styled('img')`
	border-radius: 8px 8px 0 0;
	max-height: 200px;
	object-fit: cover;
	width: 100%;
	aspect-ratio: 16 / 9;

	${({theme}) => theme.breakpoints.up('sm')} {
		margin-top: -16px;
		border-radius: 8px 0 0 0;
		max-height: none;
	}
`;

export {StyledIconButton, StyledImage};
